{
  const init = (picker) => {
    const formId = picker.getAttribute('form-id');
    const form = document.forms[formId];
    if (!form || form.dataset.avlxAutoSelectInit) return;
    form.dataset.avlxAutoSelectInit = 'true';

    let correcting = false;

    form.addEventListener('variant:change', (e) => {
      if (correcting) return;
      const variant = e.detail?.variant;

      // Only intervene on INVALID combinations (variant === null), not
      // sold-out variants. Sold-out variants are valid combos whose
      // inventory ran out — the customer should see the Klaviyo BIS form
      // rather than being silently redirected to an in-stock alternative.
      if (variant !== null) return;

      // Variant-picker inputs associate to the form via form="..." but live
      // outside the form's DOM subtree, so use form.elements (not querySelector).
      const elements = Array.from(form.elements);

      const checkedUnavailable = elements.filter((el) =>
        el.matches('input[data-option-position][data-unavailable]:checked')
      );

      checkedUnavailable.forEach((badInput) => {
        const position = badInput.getAttribute('data-option-position');
        const firstAvailable = elements.find((el) =>
          el.matches(`input[data-option-position="${position}"]:not(:checked):not([data-unavailable]):not([disabled])`)
        );

        if (firstAvailable) {
          correcting = true;
          firstAvailable.checked = true;
          firstAvailable.dispatchEvent(new Event('change', { bubbles: true }));
          correcting = false;
        }
      });
    });
  };

  const run = () => document.querySelectorAll('variant-picker').forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
}
